import HeaderWebMarketing from "./homes_headers"
import "../../styles/marketing.css"
import MainHome from "./home";
import Footer from "./min_footer";
import MinTestimonial from "./min_testimonial";

function LandingHomes() {
    return (
        <div>
            <HeaderWebMarketing />
            <MainHome />
            <MinTestimonial />
            <Footer />
        </div>
    );
}

export default LandingHomes;
